const jetBaselineMenus = {
  Cargas: [
    {
      type: 'section',
      iconKey: 'lista',
      label: 'Operación base',
      items: [
        { label: 'Ingreso de Remitos', to: '/cargas/ingreso-de-remitos', iconKey: 'filePlus', featureCode: 'jet.cargas.ingreso_remitos' },
        { label: 'Revalorización de Envíos', to: '/cargas/revalorizacion-de-envios', iconKey: 'facturacion', featureCode: 'jet.cargas.revalorizacion_envios' },
        { label: 'Consulta de Envíos', to: '/guias/consulta', iconKey: 'busqueda', featureCode: 'jet.cargas.consulta_envios' },
        { label: 'Confirmación de Despachos', to: '/cargas/confirmacion-de-despachos', iconKey: 'confirmar', featureCode: 'jet.cargas.confirmacion_despachos' },
        { label: 'Recanalizador de Carga', to: '/cargas/recanalizador-de-carga', iconKey: 'rutas', featureCode: 'jet.cargas.recanalizador' },
        { label: 'Fojas de Ruta', to: '/cargas/fojas-de-ruta', iconKey: 'rutas', featureCode: 'jet.cargas.fojas_ruta' },
        { label: 'Definición de Líneas', to: '/cargas/definicion-de-lineas', iconKey: 'lineas', featureCode: 'jet.cargas.definicion_lineas' },
      ],
    },
    {
      type: 'section',
      iconKey: 'alertas',
      label: 'Novedades y distribución',
      items: [
        { label: 'Entregas Conforme en Gral', to: '/cargas/novedades/entregas-conforme-en-gral', iconKey: 'confirmar', featureCode: 'jet.cargas.entregas_conforme' },
        { label: 'Carga Retenida', to: '/cargas/retenidas', iconKey: 'alertas', featureCode: 'jet.cargas.cargas_retenidas' },
        { label: 'Corrección de Novedades', to: '/cargas/correccion-novedades', iconKey: 'ajustes', featureCode: 'jet.cargas.correccion_novedades' },
        { label: 'Armado del Reparto', to: '/repartos/nuevo', iconKey: 'repartos', featureCode: 'jet.cargas.armado_reparto' },
        { label: 'Planillas de Distribución', to: '/repartos', iconKey: 'lista', featureCode: 'jet.cargas.planillas_distribucion' },
        { label: 'Documentación por Bolsa', to: '/cargas/documentacion-por-bolsa', iconKey: 'guias', featureCode: 'jet.cargas.documentacion_bolsa' },
      ],
    },
  ],
  'Ctas Ctes': [
    {
      type: 'section',
      iconKey: 'facturacion',
      label: 'Facturación operativa',
      items: [
        { label: 'Consulta de FC-DB-CR', to: '/facturacion/facturas', iconKey: 'files', featureCode: 'jet.ctasctes.consulta_comprobantes' },
        { label: 'Emisión de FC-DB-CR Manuales', to: '/facturacion/manual/nueva', iconKey: 'filePlus', featureCode: 'jet.ctasctes.emision_manual' },
        { label: 'Emisión de Facturas por Remitos', to: '/facturacion/desde-guias', iconKey: 'facturacion', featureCode: 'jet.ctasctes.emision_por_remitos' },
      ],
    },
  ],
  Gerencial: [
    {
      type: 'section',
      iconKey: 'usuarios',
      label: 'Seguridad y parametría',
      items: [
        { label: 'ABMCL de Perfil de Usuario y Excepciones', to: '/gerencial/usuarios', iconKey: 'usuarios', featureCode: 'jet.gerencial.perfiles_usuarios' },
      ],
    },
    {
      type: 'section',
      iconKey: 'reportes',
      label: 'Gestión y estadísticas',
      items: [
        { label: 'Corrección de Novedades', to: '/cargas/correccion-novedades', iconKey: 'ajustes', featureCode: 'jet.gerencial.correccion_novedades' },
        { label: 'Control de Calidad', to: '/informes/calidad', iconKey: 'reportes', featureCode: 'jet.gerencial.control_calidad' },
        { label: 'Control de Calidad x Cobranza', to: '/informes/calidad', iconKey: 'reportes', featureCode: 'jet.gerencial.control_calidad_cobranza' },
        { label: 'Cobranzas por Sucursal', to: '/gerencial/reportes', iconKey: 'tesoreria', featureCode: 'jet.gerencial.cobranzas_sucursal' },
        { label: 'Totales Transportados por Cliente', to: '/informes/productividad', iconKey: 'reportes', featureCode: 'jet.gerencial.totales_cliente' },
        { label: 'Totales Transportados por Foja', to: '/gerencial/reportes', iconKey: 'reportes', featureCode: 'jet.gerencial.totales_foja' },
        { label: 'Producción por Sucursal', to: '/gerencial/reportes', iconKey: 'dashboard', featureCode: 'jet.gerencial.produccion_sucursal' },
      ],
    },
  ],
  'Tesorería': [
    {
      type: 'section',
      iconKey: 'cobros',
      label: 'Cobranza y cuenta corriente',
      items: [
        { label: 'Resumen de Cuenta de Clientes', to: '/ctasctes/cuenta-corriente-clientes/resumen-de-cuenta', iconKey: 'reportes', featureCode: 'jet.tesoreria.resumen_cta_clientes' },
        { label: 'Análisis de Deuda por Cliente', to: '/ctasctes/reportes/analitico-de-deuda-clientes', iconKey: 'reportes', featureCode: 'jet.tesoreria.analisis_deuda_clientes' },
        { label: 'Minutas de Cobranzas', to: '/tesoreria/minutas', iconKey: 'agenda', featureCode: 'jet.tesoreria.minutas_cobranzas' },
        { label: 'Ingreso de Contrareembolsos', to: '/tesoreria/cobranzas/seguimiento-de-contrareembolsos-cobrados', iconKey: 'tesoreria', featureCode: 'jet.tesoreria.ingreso_contrareembolsos' },
        { label: 'Cobrar Contados con CP-R', to: '/tesoreria/cobranzas', iconKey: 'registrar', featureCode: 'jet.tesoreria.cobrar_contados_cpr' },
        { label: 'Recibo Cta Cte y Contados c/ Factura', to: '/tesoreria/cobranzas/ingreso-de-recibos', iconKey: 'comprobantes', featureCode: 'jet.tesoreria.recibos_ctacte_contados' },
        { label: 'Aplicar N/C y Pagos a Cuenta', to: '/tesoreria/cobranzas/ingreso-de-recibos', iconKey: 'notas', featureCode: 'jet.tesoreria.aplicar_nc_pagos_cuenta' },
        { label: 'Subdiario de Cobranzas', to: '/tesoreria/cobranzas/rendicion-de-cobranzas', iconKey: 'historial', featureCode: 'jet.tesoreria.subdiario_cobranzas' },
      ],
    },
    {
      type: 'section',
      iconKey: 'tesoreria',
      label: 'Bancos y valores',
      items: [
        { label: 'Registro de Bancos', to: '/administracion/bancos-y-valores/bancos', iconKey: 'tesoreria', featureCode: 'jet.tesoreria.registro_bancos' },
        { label: 'Cuentas Bancarias', to: '/tesoreria/bancos-y-conciliacion/movimientos-bancarios', iconKey: 'tesoreria', featureCode: 'jet.tesoreria.cuentas_bancarias' },
        { label: 'Consultar Cheques de Terceros', to: '/tesoreria/proveedores-y-pagos/cheques-de-terceros', iconKey: 'tesoreria', featureCode: 'jet.tesoreria.cheques_terceros' },
        { label: 'Distribución de Valores CRR', to: '/tesoreria/cobranzas/depositos-de-cobranzas-en-efectivo', iconKey: 'lista', featureCode: 'jet.tesoreria.distribucion_valores_crr' },
      ],
    },
  ],
  'Administración': [
    {
      type: 'section',
      iconKey: 'administracion',
      label: 'Tablas y parámetros',
      items: [
        { label: 'Menú de Listados de Clientes', to: '/clientes', iconKey: 'usuarios', featureCode: 'jet.admin.listados_clientes' },
        { label: 'Conceptos de Valorización', to: '/administracion/maestros/conceptos-de-valorizacion', iconKey: 'lista', featureCode: 'jet.admin.conceptos_valorizacion' },
        { label: 'Consulta de Tarifas x Cliente', to: '/administracion/tarifas/consulta-de-tarifas-clientes-o-fleteros', iconKey: 'ajustes', featureCode: 'jet.admin.consulta_tarifas_cliente' },
        { label: 'Remitentes/Destinatarios Habituales', to: '/clientes', iconKey: 'usuarios', featureCode: 'jet.admin.remitentes_destinatarios_habituales' },
        { label: 'Direcciones E-mail Automáticos', to: '/administracion/empresa/plantilla-de-impresion-de-guias', iconKey: 'agenda', featureCode: 'jet.admin.direcciones_email_automaticos' },
        { label: 'Maestro de Tarifas', to: '/administracion/tarifas/tarifas-para-clientes', iconKey: 'ajustes', featureCode: 'jet.admin.maestro_tarifas' },
        { label: 'Listas de Precios', to: '/administracion/tarifas/tarifas-para-clientes', iconKey: 'files', featureCode: 'jet.admin.listas_precios' },
        { label: 'Ajuste de Precios', to: '/tarifas', iconKey: 'ajustes', featureCode: 'jet.admin.ajuste_precios' },
        { label: 'Emitir Cuadro Tarifario', to: '/administracion/tarifas/tarifas-para-clientes', iconKey: 'reportes', featureCode: 'jet.admin.emitir_cuadro_tarifario' },
        { label: 'Historial de Tarifas', to: '/tarifas', iconKey: 'historial', featureCode: 'jet.admin.historial_tarifas' },
        { label: 'Localidades Atendidas', to: '/administracion/empresa/localidades-atendidas', iconKey: 'administracion', featureCode: 'jet.admin.localidades_atendidas' },
        { label: 'Numeradores Tarifarios', to: '/administracion/tarifas/numeradores-tarifarios', iconKey: 'lista', featureCode: 'jet.admin.numeradores_tarifarios' },
        { label: 'Localidades por Canalización', to: '/administracion/empresa/rutas-de-distribucion', iconKey: 'rutas', featureCode: 'jet.admin.localidades_canalizacion' },
        { label: 'Tabla de Inconvenientes', to: '/administracion/maestros/motivos-de-inconvenientes', iconKey: 'alertas', featureCode: 'jet.admin.tabla_inconvenientes' },
        { label: 'Transportes para Redespachos', to: '/administracion/redespachos', iconKey: 'rutas', featureCode: 'jet.admin.transportes_redespachos' },
        { label: 'Actualización de Rubros', to: '/administracion/maestros/rubros', iconKey: 'lista', featureCode: 'jet.admin.actualizacion_rubros' },
        { label: 'Tipo de Unidades Habilitadas', to: '/administracion/maestros/unidades-de-medida', iconKey: 'vehiculos', featureCode: 'jet.admin.tipo_unidades_habilitadas' },
        { label: 'Actualización de Flota', to: '/administracion/flota', iconKey: 'vehiculos', featureCode: 'jet.admin.actualizacion_flota' },
        { label: 'Actualizar Choferes y Fleteros', to: '/administracion/choferes', iconKey: 'choferes', featureCode: 'jet.admin.actualizar_choferes_fleteros' },
        { label: 'Actualización de Cobradores', to: '/administracion/maestros/actualizacion-de-cobradores', iconKey: 'usuarios', featureCode: 'jet.admin.actualizacion_cobradores' },
        { label: 'Actualización de Vendedores', to: '/administracion/maestros/actualizacion-de-vendedores', iconKey: 'usuarios', featureCode: 'jet.admin.actualizacion_vendedores' },
      ],
    },
  ],
};

export default jetBaselineMenus;
